import React, { useEffect, useState } from "react";
import Footer from "../Footer";
import Sidebar from "../sidebar";
import Topnav from "../TopNav";
import { API_URL, token } from "../config";

const PendingBal = () => {
    const [pendingWithdrawals, setPendingWithdrawals] = useState([]);
    const [totalPending, setTotalPending] = useState(0);
    const [show, setShow] = useState(false);

    const toggleSidebar = () => {
        setShow(prevShow => !prevShow);
    };

    useEffect(() => {
        const fetchPending = async () => {
            try {
                const response = await fetch(`${API_URL}/authors/withdrawals`, {
                    headers: { 'Authorization': `Bearer ${token()}` }
                });
                const data = await response.json();
                if (response.ok && data.withdrawals) {
                    const pending = data.withdrawals.filter(w => w.status === 'pending');
                    setPendingWithdrawals(pending);
                    const total = pending.reduce((sum, w) => sum + parseFloat(w.amount), 0);
                    setTotalPending(total);
                }
            } catch (error) {
                console.error('Error fetching pending withdrawals:', error);
            }
        };

        fetchPending();
    }, []);

    return (
        <html lang="en">
            <body>
                <div className="wrapper">
                    <Sidebar show={show} />
                    <div className="main-panel">
                        <Topnav toggleSidebar={toggleSidebar} />
                        <div className="container">
                            <div className="page-inner">
                                <div className="d-flex align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
                                    <h3 className="fw-bold mb-3">Pending Withdrawals: ${totalPending}</h3>
                                </div>
                                <p className="fw-bold mb-3">These withdrawals are being processed and will be cleared within 48 hours.</p>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card">
                                            <div className="table-responsive pt-3">
                                                <table className="table table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th>Date Requested</th>
                                                            <th>Amount</th>
                                                            <th>Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {pendingWithdrawals.map((w, index) => (
                                                            <tr key={index}>
                                                                <td>{new Date(w.requested_at).toLocaleDateString()}</td>
                                                                <td>${w.amount}</td>
                                                                <td><span className="badge bg-warning">{w.status}</span></td>
                                                            </tr>
                                                        ))}
                                                        {pendingWithdrawals.length === 0 && (
                                                            <tr><td colSpan="3" className="text-center">No pending withdrawals</td></tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <footer className="footer">
                            <Footer />
                        </footer>
                    </div>
                </div>
            </body>
        </html>
    );
};

export default PendingBal;